<template>
    <div class="commentsContainer">
        <template v-if="modify">
            <new-comment-form v-model="vm" @add="$emit('add', $event)" v-if="!readonly"></new-comment-form>
        </template>
        <div class="scrollListContainer">
            <div class="emptyState" v-if="comments.length == 0">
                Nessun commento
            </div>
            <template v-else>
                <div class="comment" v-for="item in comments" :key="item.identifier">
                    <div class="avatar">{{ item.author.name.charAt(0).toUpperCase() }}</div>
                    <div class="comment-content">
                        <div class="comment-meta">
                            <span class="author">{{ item.author.name }}</span>
                            <span class="date">{{ $filters.date(item.createdOn, 'DD-MM-YYYY HH:mm') }}</span>
                            <button type="button" class="btn-delete" v-if="$store.state.isSuperAdmin()" @click="deleteComment(item)">×</button>
                        </div>
                        <div class="comment-body">
                            <comment-text :comment="item"></comment-text>
                            <template v-if="item.attachments.length > 0">
                                <div v-for="(x, i) in item.attachments" :key="i" class="attachment-link">
                                    <a :href="x.publicUrl" target="_blank">
                                        <icon-clip></icon-clip> {{ x.filename }}
                                    </a>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import Component, { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class commentsContainer extends Vue {

    @Prop() comments: OM.Comment[];
    @Prop() readonly: boolean;
    @Prop({
        type: Boolean,
        default: true
    }) modify: boolean;


    vm: VM.AddCommentVm = new VM.AddCommentVm();

    commentText: string = "";

    deleteComment(item: OM.Comment){
        if(!confirm("Confermi?")){
            return;
        }
        this.$emit('deleteComment', item);
    }

}

</script>

<style scoped>

.commentsContainer {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.scrollListContainer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 480px;
    overflow-y: auto;
    padding-right: 4px;
}

.emptyState {
    color: #6c757d;
    font-size: 0.875rem;
    padding: 8px 0;
}

.comment {
    display: flex;
    gap: 10px;
    background: #f8f9fa;
    border-left: 3px solid #029394;
    border-radius: 0 6px 6px 0;
    padding: 10px 14px;
}

.avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #029394;
    color: white;
    font-size: 0.75rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
}

.comment-content {
    flex: 1;
    min-width: 0;
}

.comment-meta {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 4px;
}

.author {
    font-weight: 600;
    font-size: 0.875rem;
    color: #212529;
}

.date {
    font-size: 0.72rem;
    color: #6c757d;
}

.btn-delete {
    background: none;
    border: none;
    color: #dc3545;
    font-size: 1rem;
    line-height: 1;
    padding: 0 2px;
    cursor: pointer;
    opacity: 0.5;
    margin-left: auto;
}

.btn-delete:hover {
    opacity: 1;
}

.comment-body {
    font-size: 0.875rem;
    color: #444;
    line-height: 1.5;
}

.attachment-link {
    margin-top: 6px;
    font-size: 0.8rem;
}

.attachment-link a {
    color: #029394;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.attachment-link a:hover {
    text-decoration: underline;
}

</style>